import theme from "@/theme";
import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    width: "100%",
  },

  label: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    marginBottom: "6px",
  },

  inputsWrapper: {
    display: "flex",
    gap: "13px",
    fontSize: "20px",
  },

  helperText: {
    display: "flex",
    height: "16px",
    mt: 0.5,
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
  },
};
export const getInputStyle = (
  hasValue: boolean,
  error?: boolean,
  inputStyle?: React.CSSProperties
): SxProps<Theme> => ({
  "& .MuiInputBase-root::before": {
    borderBottom: `1px solid ${
      error ? theme.palette.error.main : hasValue ? theme.palette.custom.mainBlue : "#D3DAE4"
    } !important`,
    transition: "border-bottom 0.3s ease",
  },

  "& input": {
    caretColor: theme.palette.custom.mainBlue,
    color: error ? theme.palette.error.main : theme.palette.custom.mainBlue,
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "20px",
    height: "45px",
    width: "54px",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  ...inputStyle,
});
